import React, { useState } from "react";
import styled from "@mui/system/styled";
// import { Paper, Button, Typography, Link as MUIlink } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import FileDownload from "@mui/icons-material/FileDownload";

const FileButtonWrapper = styled("div")`
  margin: 10px 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  & > button {
    margin: 4px 0 8px;
  }
`;
const DownloadItem = ({
  fileItem,
  buttonText = "Download file",
  isDownloading = false,
  onDownload,
}) => {
  return (
    <FileButtonWrapper>
      <LoadingButton
        size="small"
        variant="contained"
        loadingPosition="end"
        loading={isDownloading}
        onClick={() => onDownload(fileItem)}
        endIcon={
          <FileDownload color={isDownloading ? "disabled" : "secondary"} />
        }
        fullWidth
        download
      >
        {buttonText}
      </LoadingButton>
    </FileButtonWrapper>
  );
};

export default React.memo(DownloadItem);
